import { PayrollCountryType } from '@nxsys/types/models/Common';
import { roles } from '@nxsys/store/constants';
import { lazy } from 'react';

const SubmitPSR = lazy(
  () => import('../../../modules/submitPSR'),
);

export const submitPSRConfig = (
  payrollCountry: PayrollCountryType,
) => {
  if (payrollCountry !== 'IRELAND') return [];
  return [
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/submit-psr',
      element: <SubmitPSR />,
    },
  ];
};
